import { buildDetailsUrl, editOnly } from 'routing/constants'
import { sortSiteHistoriesInPlace } from './siteHistories'
import { resolveEditOnlyRouteIds } from './editOnlyNavigation'
import { getEditOnlyContext } from './editOnlyContext'

export function resolveSiteHistoryId(site = {}) {
  return site.historyId ?? site.sitehistoryId ?? null
}

export function navigateDetails(history, siteId, historyId, editOnlyRoute) {
  history(buildDetailsUrl(siteId, historyId, editOnlyRoute))
}

export function navigateEditOnlySite(history, site, editOnlyRoute) {
  if (site.reassessmentFlag && !editOnlyRoute) {
    const siteId = site.siteId || site.SiteId || site.Site?.id || site.id
    return navigateDetails(history, siteId, resolveSiteHistoryId(site), editOnlyRoute)
  }
  const { siteId, editOnlySiteId } = resolveEditOnlyRouteIds(site)
  navigateDetails(history, siteId, editOnlySiteId, editOnlyRoute)
}

/**
 * Live confirmed / delisted / DNQ / not-assessed catalog rows should open the parent Site
 * (GET /sites/:id). Approve-edits merges onto SiteModel; opening a specific historyId can
 * show a stale snapshot that never received the merge.
 */
export function createNavigateRfpStyleViewSite(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.reassessmentFlag) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Uses full SitesHistories for in-flight reassessment; live catalog rows open Site. */
export function createNavigateViewSiteWithAllHistories(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.reassessmentFlag) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Individual confirmed / delisted / DNQ: open merged Site (not a history snapshot). */
export function createNavigateIndividualConfirmedView(site, history, editOnlySite) {
  return () => {
    navigateDetails(history, site.id)
  }
}

/** Individual role fallback viewSite (historyId || sitehistoryId when flag/edit-only). */
export function createNavigateIndividualDefaultViewSite(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.SitesHistories?.length > 0) {
      sortSiteHistoriesInPlace(site.SitesHistories)
      return navigateDetails(history, site.id, site.SitesHistories[0].historyId, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Review row: reassessment or edit-only uses history with optional editOnly route; else base details. */
export function createNavigateReviewDetails(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    const context = getEditOnlyContext(site)
    const isEditOnly = Boolean(editOnlySiteStatus || context.editOnlySiteStatus)
    if (isEditOnly) {
      return navigateEditOnlySite(history, site, editOnlySite || context.editOnlySite || editOnly)
    }
    if (site.reassessmentFlag) {
      return navigateDetails(history, site.id, resolveSiteHistoryId(site))
    }
    navigateDetails(history, site.id)
  }
}

/** Individual "review" when reviewed by RFP: uses site.historyId only (no sitehistoryId fallback). */
export function createNavigateIndividualReviewedByRfp(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}
